import {Container, Box} from './style.js';
import Logotipo from '../../assets/logo.png';

function Footer() {
  return (
    <Container>
        <div className='content'>
            <Box>
                <img src={Logotipo} alt="Logotipo Contavares" />
            </Box>
            <Box>
                <h2>Contatos</h2>
                <h4>Suporte</h4>
                <h4>suporte@contavares.com.br</h4>
                <h4>(85) 85 99787-7058</h4>
            </Box>
            <Box>
                <h2>Endereço</h2>
                <h4>R. Firmino Rocha Aguiar, 801 - Guararapes, Fortaleza - CE, 60810-165</h4>
            </Box>
        </div>
    </Container>
  );
}
export default Footer;